import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CKEDITOREMAILCONFIG } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { LeadEmailTemplate } from '../lead-email-template';
import { ToastMessageService } from '../toast-message.service';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-create-lead-email-template',
  templateUrl: './create-lead-email-template.component.html',
  styleUrls: ['./create-lead-email-template.component.css']
})
export class CreateLeadEmailTemplateComponent implements OnInit {

  languages: Language[] = [];
  templateForm!: FormGroup;
  processing = false;

  emailEditorConfig = CKEDITOREMAILCONFIG;

  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.httpService.getLanguages().subscribe(res => this.languages = res);
    this.templateForm = this.builder.group({
      name: [null, Validators.required],
      body: [null, Validators.required],
      language: [null, Validators.required],
      subject: [null, Validators.required]
    });
  }

  sendTemplate(){
    let template = new LeadEmailTemplate(
      this.templateForm.value.name,
      this.templateForm.value.body,
      this.templateForm.value.language,
      this.templateForm.value.subject
    );
    if(this.templateForm.valid){
      this.processing = true;
      this.httpService.postLeadEmailTemplate(template).subscribe(() => {
        this.toastService.addSuccess("Success", "Template created");
        this.processing = false;
      }, error => {
        this.processing = false;
        this.toastService.addError("Error", error.message);
      });
    } else {
      this.toastService.addError("Error", "Please complete all informations");
    }
  }

}
